import { render } from "./TableCompanyShare.vue?vue&type=template&id=ec857d56"
import script from "./TableCompanyShare.vue?vue&type=script&lang=js"
export * from "./TableCompanyShare.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__